import KeyboardSkeleton from './keyboardSkeleton';
import Input from './input';
import forgotPassword from './forgotPassword';

const signature = (data) => (`
  <div id="signature-digital">
    ${Input()}
    <div id="signature-digital__group">
    </div>
    <span class="signature-digital__error">A assinatura eletrônica digitada está incorreta, por favor, tente novamente.</span>
    ${forgotPassword()}
  </div>
`);

export default signature;